type WorkOfferPostulationModalIcon = "error" | "warning";

export type WorkOfferPostulationErrorModal = {
  title: string;
  body: string;
  iconType: WorkOfferPostulationModalIcon;
};

const DEFAULT_FAILURE_MESSAGE =
  "No pudimos procesar tu postulación, por favor inténtalo nuevamente en unos minutos o escríbenos a contacto@edify.la ¡Muchas gracias!";

function extractBackendMessage(err: unknown): string | null {
  const message = (err as { response?: { data?: { message?: string } } })?.response?.data?.message;
  if (typeof message !== "string") return null;
  const trimmed = message.trim();
  return trimmed.length > 0 ? trimmed : null;
}

function extractStatus(err: unknown): number | null {
  const status = (err as { response?: { status?: number } })?.response?.status;
  return typeof status === "number" ? status : null;
}

export function resolveWorkOfferPostulationErrorModal(err: unknown): WorkOfferPostulationErrorModal {
  const status = extractStatus(err);
  const backendMessage = extractBackendMessage(err);

  if (status === 409) {
    return {
      title: "Ya te postulaste",
      body: backendMessage ?? "Ya registramos una postulación tuya para esta oferta.",
      iconType: "warning",
    };
  }

  if (status === 404) {
    return {
      title: "Oferta no disponible",
      body: backendMessage ?? "No encontramos esta vacante. Puede que haya sido cerrada o eliminada.",
      iconType: "error",
    };
  }

  if (status === 400) {
    return {
      title: "Revisá tu postulación",
      body: backendMessage ?? "Debés adjuntar un CV para postularte.",
      iconType: "error",
    };
  }

  return {
    title: "¡Ups!",
    body: backendMessage ?? DEFAULT_FAILURE_MESSAGE,
    iconType: "error",
  };
}
